import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'affiliateLogo';
  const widgetOpts = affiliateLogoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    moreButton: false,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomSeo(widgetData);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, URL, ImageWithPath } = widgetData[0];
    const $seo = $(`#${widgetName}`).find('.card-widget-item');
    const urlAttribute = isLocalUrl(URL) ? '' : "target='_blank'";

    $seo.replaceWith(`
      <a ${URL ? 'href="' + URL + '"' : ''} class='affiliate-logo lozad ${!URL ? 'void-link' : ''}' ${urlAttribute} aria-label="${Title}" title="${Title}" data-background-image="${ImageWithPath}" style="background-image: url('${ImageWithPath}'); background-size: contain; background-position: center; background-repeat: no-repeat;"></a
    `);
  }
}
